import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_caret",
  "use": "svg_caret-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 8\" id=\"svg_caret\"><path d=\"m1 1.5 5 5 5-5\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol